import axios from "axios";
import Vue from 'vue'
const server_path =
  process.env.VUE_APP_HTTP_S +
  "://" +
  process.env.VUE_APP_API_HOST +
  ":" +
  process.env.VUE_APP_API_PORT +
  "/api/";
const url_geoserver = process.env.VUE_APP_GEORSERVER_URL;
export function getData(url) {
  return axios
    .get(server_path + url)
    .then(res => res)
    .catch(error => error);
}
export function getOutsideData(url) {
  return axios
    .get(url)
    .then(res => res)
    .catch(error => error);
}

export function setData(url, data) {
  return axios
    .post(server_path + url, data)
    .then(res => res)
    .catch(error => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
}

export function putData(url, id, data) {
  return axios
    .put(server_path + url + id + "/" , data)
    .then(res => res)
    .catch(error => {
      return Promise.reject(error.response)
    });
}

export function deleteData(url, id) {
  return axios
    .delete(server_path + url + id + "/")
    .then(res => res)
    .catch(error => error);
}

export function upload(form, file) {
  const url = server_path + "upload/";
  const formData = new FormData();
  for (const key in form) {
    formData.append(key, form[key]);
  }
  formData.append("file", file);
  return axios
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(res => res)
    .catch(error => {
      return Promise.reject(error.response)
    });
}


//////////////////// API GEOSERVER /////////////////////////////////////////////////
export function checkWorkspaces() {

// Parametrizar username, password y url_geoserver en el .env!
var username = process.env.VUE_APP_GEOUSERNAME;
var password = process.env.VUE_APP_GEOPASSWORD;
var basicAuth = 'Basic ' + btoa(username + ':' + password);
return axios
    .get(url_geoserver + 'workspaces', {
      headers: {
        'Authorization': basicAuth
      }
      }).then(res =>  res)
        .catch(err => this.$noty.error("Oops, something went wrong!: ", err));
}



// WEBPACK FOOTER //
// ./src/services/api.js